import { useEffect, useRef } from "react";
import {useWindowResize} from "../../../../hooks/common/UseWindowResize";

const DynamicSizeRow = ({
    data,
    index,
    setSize,
    setCurrentIndex,
    children
}) => {
    const rowRef = useRef();
    const [windowWidth] = useWindowResize();

    useEffect(() => {
        setSize(index, rowRef.current.getBoundingClientRect().height);
        setCurrentIndex(index);
    }, [setSize, index, windowWidth]);

    // A row's own content can grow/shrink later (e.g. an async check resolving into more content)
    // without index/windowWidth changing, so the effect above alone misses it — observe directly.
    useEffect(() => {
        const el = rowRef.current
        const observer = new ResizeObserver(([entry]) => {
            setSize(index, entry.target.getBoundingClientRect().height);
        })
        observer.observe(el)
        return () => observer.disconnect()
    }, [setSize, index]);

    return (
        <div ref={rowRef}>
            {children(data[index], index)}
        </div>
    );
};

export default DynamicSizeRow;